import { ReactNode } from "react";
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent
} from "../ui/tooltip";
import { InfoCircledIcon } from "@radix-ui/react-icons";
import { Text } from "@radix-ui/themes";
import cn from "classnames";

interface FormInfoProps {
  className?: string;
  iconClassName?: string;
  children: ReactNode;
  side?: "top" | "bottom" | "left" | "right";
  mt?: string;
  ml?: string;
}

export const InfoTooltip = ({ children, className, iconClassName, side, ml = "2", mt = "0" }: FormInfoProps) => (
  <Tooltip delayDuration={150}>
    <TooltipTrigger style={{ marginLeft: ml, marginTop: mt }} asChild>
      <InfoCircledIcon className={cn("ml-2", iconClassName)} />
    </TooltipTrigger>
    <TooltipContent
      side={side ?? "bottom"}
      className={
        cn(
          "p-2 w-1/2 select-none",
          className ? className : ""
        )
      }>
      <Text size="2">
        {children}
      </Text>
    </TooltipContent>
  </Tooltip>
)
